import React from "react";
import Header from "./components/Header";
import Banner from "./components/Banner";
import ServicesSection from "./components/ServicesSection";
import ConvertrexSection from "./components/ConvertrexSection";
import TrafficFlow from "./components/TrafficFlow";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import { LanguageProvider } from "./contexts/LanguageContext";
import "./styles.css";

const App = () => {
  return (
    <LanguageProvider>
      <div className="app">
        <Header />
        <main>
          <Banner />
          <ServicesSection />
          <ConvertrexSection />
          <TrafficFlow />

          <ContactSection />
        </main>
        <Footer />
        <FloatingButtons />
      </div>
    </LanguageProvider>
  );
};

export default App;
